import Image from 'next/image'
import { useState } from 'react'
import { GameCardTags } from 'src/components/GameCard/components/GameCardTags'
import type { MarbleGame } from 'src/types/domain/Game'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import { getTranslatedGameTitle, getTranslatedGameDescription } from 'src/services/i18n/utils/gameTranslations'
import { getLatestEvent } from 'src/utils/raceUtils'
import { TrackHighlightButton } from './TrackHightlightButton'

type Props = Readonly<{
  game: MarbleGame
  isCurrent: boolean
  onClick: () => void
}>

export function TrackHighlightCard({ game, isCurrent, onClick }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  const latestEvent = getLatestEvent(game.races[0].raceEvents)
  const [loaded, setLoaded] = useState(false)

  if (!latestEvent) return null

  const isScheduled = latestEvent.eventType === 'race_scheduled'
  const translatedTitle = getTranslatedGameTitle(game.track, t)

  return (
    <div className="show-track-highlight-inner">
      <div className={`show-track-highlight-poster ${isScheduled ? 'is-scheduled' : ''} ${!loaded ? 'loading' : ''}`}>
        <Image
          alt={translatedTitle}
          className={loaded ? 'loaded' : 'loading'}
          fill
          onLoad={() => { setLoaded(true) }}
          priority
          sizes="200px"
          src={game.track.background}
        />
      </div>

      <div className="show-track-highlight-content">
        <h3>{translatedTitle}</h3>
        <GameCardTags />
        <p>{getTranslatedGameDescription(game.track, t)}</p>

        <TrackHighlightButton
          game={game}
          isCurrent={isCurrent}
          isScheduled={isScheduled}
          onClick={onClick}
        />
      </div>
    </div>
  )
}
